import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47f37eb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = { class: "mediacalBox" }
const _hoisted_4 = { class: "mediacalBack" }
const _hoisted_5 = { class: "mediaclText" }
const _hoisted_6 = { class: "left" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sex" }, "情报3:治疗前评估", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "age" }, "女，76岁", -1))
const _hoisted_9 = { class: "right" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bottom" }, null, -1))
const _hoisted_11 = { class: "boxTail" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "leftright" }, null, -1))
const _hoisted_13 = { class: "textBox" }
const _hoisted_14 = { class: "innerText" }
const _hoisted_15 = { class: "leftBox" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rightBox" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "topbox" }, [
    /*#__PURE__*/_createElementVNode("span", null, "主观评价")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "desttext" }, [
    /*#__PURE__*/_createTextVNode(" 药物评分:0"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("症状评分:3"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("生活质量评分(PQLQ)：73"),
    /*#__PURE__*/_createElementVNode("br")
  ])
], -1))
const _hoisted_17 = { class: "innerText" }
const _hoisted_18 = { class: "leftBox" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "rightBox" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "topbox" }, [
    /*#__PURE__*/_createElementVNode("span", null, "客观评价")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "desttext" }, "细胞因子检查：IL-5:6.86")
], -1))
const _hoisted_20 = { class: "btnBox" }
const _hoisted_21 = { class: "bxs" }
const _hoisted_22 = { class: "ip" }
const _hoisted_23 = {
  style: {"width":"4rem","margin":"0 auto"},
  class: "home"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_question = _resolveComponent("question")!
  const _component_correct = _resolveComponent("correct")!
  const _component_reason = _resolveComponent("reason")!
  const _component_jiexiao = _resolveComponent("jiexiao")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_toNav = _resolveComponent("toNav")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_van_image, {
          src: require('../assets/logo.png')
        }, null, 8, ["src"])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_van_image, {
                  width: "2.3067rem",
                  height: "2.52rem",
                  src: require('../assets/fangdajing.png')
                }, null, 8, ["src"])
              ])
            ])
          ]),
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_van_image, {
                    class: "rightImg",
                    width: ".64rem",
                    height: ".6133rem",
                    src: require('../assets/duigou.png')
                  }, null, 8, ["src"])
                ]),
                _hoisted_16
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_van_image, {
                    class: "rightImg",
                    width: ".64rem",
                    height: ".6133rem",
                    src: require('../assets/duigou.png')
                  }, null, 8, ["src"])
                ]),
                _hoisted_19
              ])
            ])
          ])
        ])
      ], 512), [
        [_vShow, $data.chatiShow]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createVNode(_component_van_image, {
            onClick: $options.jiexiaoChanged,
            width: "2.44rem",
            height: "3.5333rem",
            src: require('../assets/zhentan.png')
          }, null, 8, ["onClick", "src"])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_van_image, {
            onClick: $options.showPopup,
            width: "5.64rem",
            height: "1.3333rem",
            src: require('../assets/button.png')
          }, null, 8, ["onClick", "src"]),
          _createVNode(_component_van_image, {
            class: "finger",
            width: "1.28rem",
            height: "1.28rem",
            src: require('../assets/dong.gif')
          }, null, 8, ["src"])
        ])
      ], 512), [
        [_vShow, $data.chatiShow]
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_van_popup, {
          show: $data.show,
          "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (($data.show) = $event)),
          "close-on-click-overlay": false
        }, {
          default: _withCtx(() => [
            ($data.flag == 'question')
              ? (_openBlock(), _createBlock(_component_question, {
                  key: 0,
                  onOnChanged: $options.updateChanged,
                  postaimqus: $data.postaimqus
                }, null, 8, ["onOnChanged", "postaimqus"]))
              : _createCommentVNode("", true),
            ($data.flag == 'correct')
              ? (_openBlock(), _createBlock(_component_correct, {
                  key: 1,
                  onOnChanged: $options.updateCorrect,
                  postaimqus: $data.postaimqus,
                  correct: $data.correct
                }, null, 8, ["onOnChanged", "postaimqus", "correct"]))
              : _createCommentVNode("", true),
            ($data.flag == 'reason')
              ? (_openBlock(), _createBlock(_component_reason, {
                  key: 2,
                  onOnChanged: $options.reasonCorrect,
                  postaimqus: $data.postaimqus
                }, null, 8, ["onOnChanged", "postaimqus"]))
              : _createCommentVNode("", true),
            ($data.flag == 'jiexiao')
              ? (_openBlock(), _createBlock(_component_jiexiao, {
                  key: 3,
                  onOnChanged: $options.jiexiaoChanged,
                  postaimqus: $data.postaimqus
                }, null, 8, ["onOnChanged", "postaimqus"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["show"])
      ])
    ]),
    _createVNode(_component_toNav, { menu: 3 })
  ], 64))
}